// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__VOzSj","label":"Section_label__2XHWh","contentWrap":"Section_contentWrap__3EFhv","footer":"Section_footer__WWVab","footerInner":"Section_footerInner__26AyB"};